module.exports = __webpack_public_path__ + "static/img/jinggao.97485487.png";